import React from "react";
import { FieldArray, useField } from "formik";
import FTextField from "./FTextField";
import { Button, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";

const FFieldArray2 = ({ name }) => {
  const [field, meta] = useField(name);
  const emptySite = "";

  return (
    <FieldArray name={name}>
      {({ push, remove }) => (
        <>
          <Box mb="15px">
            <Typography variant="h5" align="center">
              Les activités/produits
            </Typography>
          </Box>

          <Grid container spacing={2}>
            {field.value.map((_, index) => (
              <Grid item container key={index} alignItems="center" spacing={2}>
                <Grid item xs={12} sm={10}>
                  <FTextField
                    name={`${name}[${index}]`}
                    label="une activité/produit"
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Button
                    /*disabled={isSubmitting} */
                    variant="outlined"
                    onClick={() => remove(index)}
                  >
                    Supprimer
                  </Button>
                </Grid>
              </Grid>
            ))}
          </Grid>

          <Box>
            {typeof meta.error === "string" && meta.touched ? (
              <Typography align="center" color="error">
                {meta.error}
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center", mt: "15px" }}>
            <Button
              sx={{ margin: "0 auto" }}
              //  disabled={isSubmitting}
              variant="contained"
              onClick={() => push(emptySite)}
            >
              Ajouter une activité/produit
            </Button>
          </Box>
        </>
      )}
    </FieldArray>
  );
};

export default FFieldArray2;
